enum RoleType {
    ManagerOrContributorRoles = 'CONTRIBUTORS',
    RegularUserRoles = 'REGULAR_USERS',
}

export default RoleType;
